export default [
  {
    name: 'TagsCompaniesList',
    path: 'settings/companies/tags',
    component: () => import('pages/settings/tags/TagsCompaniesList.vue')
  },
  {
    name: 'TagsList',
    path: 'settings/companies/:id/tags',
    component: () => import('pages/settings/tags/TagsList.vue')
  },
  {
    name: 'TagsCreate',
    path: 'settings/companies/:id/tags/new',
    component: () => import('pages/settings/tags/TagsForm.vue')
  },
  {
    name: 'TagsEdit',
    path: 'settings/companies/:id/tags/:tagId/edit',
    component: () => import('pages/settings/tags/TagsForm.vue')
  }
]
